module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/blog your pathPrefix should be "blog"
  siteTitle: 'Learn something new', // Navigation and Site Title
  siteTitleAlt: 'Our growing development knowledge', // Alternative Site title for SEO
  siteTitleShort: 'Development knowledge', // short_name for manifest
  siteUrl: 'https://multiplestates.co.uk', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: 'images/logo.png', // Used for SEO and manifest, path to your image you placed in the 'static' folder
  siteDescription: 'Learn something new every day and post it here.',
  author: 'Kevin Beck', // Author for schemaORGJSONLD
  organization: 'Multiple States Ltd',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '', // Twitter Username
  ogSiteName: '', // Facebook Site Name
  ogLanguage: 'en_GB',
  googleAnalyticsID: '',

  // Manifest and Progress color
  themeColor: '#5348FF',
  backgroundColor: '#2b2e3c',

  // Social component
  twitter: '',
  twitterHandle: '',
  github: '',
  linkedin: '',
}
